import React, { useState } from 'react';
import RegisterForm from '../../../components/ui/forms/register';
import { toast } from 'react-toastify';
import { message } from 'antd';
import { register } from '../../../services/auth';
import { getErrorMessage } from '../../../utils/errorHandler';
import './Register.css';

const Register = ({ history }) => {
  const [values, setValues] = useState({
    name: '',
    username: '',
    email: '',
    phone: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);

  const { name, username, email, phone, password } = values;

  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };

  const translateErrorMessage = (message) => {
    if (message === 'All fields are required') {
      return 'Todos os campos são obrigatórios.';
    }
    return message;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await register({
        name: name,
        username: username,
        email: email,
        phone: phone,
        password: password,
      });
      console.log(res);
      message.success('Regitration successful. Please login', 4);
      history.push('/login');
    } catch (err) {
      console.log(err);
      if (err.response?.status === 400) {
        const errorMessage = getErrorMessage(err, 'Erro no registro');
        message.error(translateErrorMessage(errorMessage), 4);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='register-page'>
      <div className='register-container'>
        <div className='register-wrapper'>
          <div className='register-form-wrapper'>
            <RegisterForm
              handleSubmit={handleSubmit}
              handleChange={handleChange}
              name={name}
              username={username}
              email={email}
              phone={phone}
              password={password}
              loading={loading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
